import { render, staticRenderFns } from "./ProviderData.vue?vue&type=template&id=58584a09&lang=pug&"
import script from "./ProviderData.vue?vue&type=script&lang=js&"
export * from "./ProviderData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports